import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SkillCard from "./SkillCard.js";
import react from "../assets/skills/react.svg";
import python from "../assets/skills/python.svg";
import node from "../assets/skills/nodejs.svg";
import javascript from "../assets/skills/javascript.svg";
import linux from "../assets/skills/linux.svg";
import html from "../assets/skills/html.svg";
import git from "../assets/skills/git.svg";
import express from "../assets/skills/express.svg";
import django from "../assets/skills/django.svg";
import tensorflow from "../assets/skills/tensorflow.svg";
import mongo from "../assets/skills/mongo.svg";
import tailwind from "../assets/skills/tailwind.svg";

const Skills = () => {
  const settings = {
    dots: false,
    autoplay: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
  };
  return (
    <div id='skills' className='mt-4 text-white'>
      <h1 className='text-2xl font-bold'>Skills</h1>
      <p className='font-light text-gray-400'>Here are some of my skills</p>

      <div className='mt-4'>
        <Slider {...settings}>
          <SkillCard name='linux' experience='1 year' img={linux} />
          <SkillCard name='git' experience='1 year' img={git} />
          <SkillCard name='html' experience='3 years' img={html} />
          <SkillCard name='tailwind' experience='3 months' img={tailwind} />
          <SkillCard name='python' experience='3 years' img={python} />
          <SkillCard name='django' experience='2 years' img={django} />
          <SkillCard name='tensorflow' experience='2 years' img={tensorflow} />
          <SkillCard name='javascript' experience='1 years' img={javascript} />
          <SkillCard name='mongodb' experience='2 months' img={mongo} />
          <SkillCard name='express' experience='2 years' img={express} />
          <SkillCard name='react' experience='1 years' img={react} />
          <SkillCard name='nodejs' experience='2 years' img={node} />
        </Slider>
      </div>
    </div>
  );
};

export default Skills;
